const m = window.require("discourse/helpers/unique-id");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;